import React from 'react'

import { Form } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'

import { KeyEventUtil } from 'utils'

const CeldaCodigoBarra = ({ esFilaActiva, seleccionarProductoViaCodigoBarraHandler }) => {
  const __adminContext = React.useContext(AdminContext)

  const [codigoBarra, setCodigoBarra] = React.useState('')

  const onKeyDown = React.useCallback(
    keyEvent => {
      if (keyEvent.keyCode === 13 || keyEvent.keyCode === 9) {
        keyEvent.preventDefault()

        if (codigoBarra) {
          seleccionarProductoViaCodigoBarraHandler(codigoBarra)
          setCodigoBarra('')
        } else {
          KeyEventUtil.leaveOnKeyEvent('productoSelect')
        }
      }
    },
    [codigoBarra, seleccionarProductoViaCodigoBarraHandler]
  )

  const inputCantidadRef = React.useRef()
  React.useEffect(() => {
    if (esFilaActiva && __adminContext.valoresConfiguracionCompania.flagCodigoBarra) {
      window.setTimeout(() => {
        inputCantidadRef.current.select()
      }, 250)
    }
  }, [esFilaActiva, __adminContext.valoresConfiguracionCompania])

  return (
    <Form.InputText
      id='input-celdaCodigoBarra'
      name='input-celdaCodigoBarra'
      ref={inputCantidadRef}
      value={codigoBarra}
      onChange={e => setCodigoBarra(e.target.value)}
      onKeyDown={onKeyDown}
      autoFocus={esFilaActiva && __adminContext.valoresConfiguracionCompania.flagCodigoBarra}
    />
  )
}

export default React.memo(CeldaCodigoBarra)
